module.exports = __webpack_public_path__ + "static/entrepot-4ae49324bacc2100d3d771c5ffaf40d9.jpg";